import * as workPackageActions from "../../actions/work-package.actions";
import {WorkPackage, WorkStream} from "../../../models/responses/work-package.model";

export class StateModel {
    workPackageList: WorkPackage[] = [];
    workStreamList: WorkStream[] = [];
    workPackageMap: Map<string, WorkPackage> = new Map<string, WorkPackage>();
    activeWorkPackage: WorkPackage | null = null;
}

export const initialState = new StateModel();

export function reducer(state = initialState, action: workPackageActions.Actions) {
    switch (action.type) {
        case workPackageActions.ActionNames.SET_WORK_PACKAGES: {
            return {
                ...state,
                workPackageList: action.payload.workPackages,
            }
        }
        case workPackageActions.ActionNames.SET_WORK_STREAMS: {
            return {
                ...state,
                workStreamList: action.payload.workStreams,
            }
        }
        case workPackageActions.ActionNames.SET_ACTIVE_WORK_PACKAGE: {
            return {
                ...state,
                activeWorkPackage: action.payload.workPackage,
            }
        }
        default:
            return state;
    }
}
